import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useScrollAnimation, cn } from 'elem/compPage/battery-backup-for-home/scroll-animation-v2';

const slideImages = [
    {
        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767668898310-4wqdci-compressed-Frame%202094654851.jpg',
        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1768189729267-hd6a2c-compressed-Frame%202094654863.jpg',
    },
    {
        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767668915010-p05gbr-compressed-Frame%202094654852.jpg',
        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1768189741138-hge9iy-compressed-Frame%202094654864.jpg',
    },
    {
        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767668925165-q3mzay-compressed-Frame%202094654853.jpg',
        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1768189749507-qfpdl4-compressed-Frame%202094654865.jpg',
    },
];

export default function MillionHomes() {
    const { t } = useLang('powerbackup');
    const { locale } = getLocal();

    const { ref, isVisible } = useScrollAnimation({
        threshold: 0.1,
    });

    return (
        <div className={`${styles.MillionHomes} GtmModuleData-section`}>
            <div ref={ref} className="header">
                <h2 className={cn(isVisible, 'power-backup-title fade-up')}>{t('secB_title')}</h2>
                <p className={cn(isVisible, 'power-backup-desc fade-up')} style={{ '--animate-delay': '0.15s' } as React.CSSProperties}>
                    {t('secB_desc')}
                </p>
            </div>

            <div className={`${cn(isVisible, 'swiper-container fade-up')} `} style={{ '--animate-delay': '0.3s' } as React.CSSProperties}>
                <Swiper
                    modules={[Navigation, Pagination]}
                    slidesPerView="auto"
                    centeredSlides={true}
                    spaceBetween={24}
                    loop={true}
                    navigation={{
                        prevEl: '.swiper-button-prev',
                        nextEl: '.swiper-button-next',
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    breakpoints={{
                        0: {
                            spaceBetween: 24,
                        },
                        768: {
                            spaceBetween: 48,
                        },
                        1024: {
                            spaceBetween: 12,
                        },
                    }}
                >
                    {slideImages.map((img, index) => (
                        <SwiperSlide key={index}>
                            <div className="slide-item">
                                <EcoImg pc={img.pc} pad={img.pc} h5={img.h5} />
                            </div>
                        </SwiperSlide>
                    ))}
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-button-next"></div>
                </Swiper>
            </div>
        </div>
    );
}
